export default __webpack_public_path__ + "static/vertical-6efe146c648574ad097c31c093b2601c.png";